"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function AddReactionOutlinedIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M10.684,17.272h.022A7.373,7.373,0,0,0,15.94,15.11l-1.2-1.2a5.69,5.69,0,0,1-4.036,1.667h-.017a5.684,5.684,0,0,1-4.042-1.69l-1.206,1.2A7.373,7.373,0,0,0,10.684,17.272Z" }),
        react_1.default.createElement("path", { d: "M9.36,9.721a1.691,1.691,0,1,0-1.691,1.69A1.691,1.691,0,0,0,9.36,9.721Z" }),
        react_1.default.createElement("path", { d: "M15.4,9.721a1.691,1.691,0,1,0-1.69,1.69A1.691,1.691,0,0,0,15.4,9.721Z" }),
        react_1.default.createElement("polygon", { points: "21.296 5.747 21.296 3.126 19.596 3.126 19.596 5.747 16.975 5.747 16.975 7.446 19.596 7.446 19.596 10.067 21.296 10.067 21.296 7.446 23.917 7.446 23.917 5.747 21.296 5.747" }),
        react_1.default.createElement("path", { d: "M10.691,20.908a8.911,8.911,0,1,1,4.979-16.3l.952-1.408A10.607,10.607,0,1,0,21.3,12H19.6A8.918,8.918,0,0,1,10.691,20.908Z" })));
}
exports.default = AddReactionOutlinedIcon;
